import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';

import Modal from '@components/modal/Modal';
import useCreateSuperAdmin from './hooks/useCreateSuperAdmin';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

import Select from '@components/form/Select';

const CreateSuperAdminUserModal: React.FC = () => {
    const {
        isPosting,
        // error,
        handleChange,
        handleSubmit,
        closeModal,
        formState: { email, firstName, lastName, password, confirmPassword, site },
        siteOptions,
        shouldShowSiteOptions,
    } = useCreateSuperAdmin();
    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    return (
        <Modal closeModal={closeModal} title="Create Super Admin">
            <Form onSubmit={handleSubmit} isPosting={isPosting} onCancel={closeModal}>
                <FormRow>
                    <TextInput
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleChange}
                        label="Email address"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="firstName"
                        value={firstName}
                        onChange={handleChange}
                        label="First name"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="lastName"
                        value={lastName}
                        onChange={handleChange}
                        label="Last Name"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="password"
                        value={password}
                        onChange={handleChange}
                        label="Password"
                        type="password"
                        required
                        customValidate={validatePassword}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        label="Confirm Password"
                        type="password"
                        customValidate={validateConfirmPassword}
                        required
                    />
                </FormRow>
                {shouldShowSiteOptions && (
                    <FormRow>
                        <Select
                            name="site"
                            value={site}
                            options={siteOptions}
                            onChange={handleChange}
                            label="Site"
                            required
                        />
                    </FormRow>
                )}
            </Form>
        </Modal>
    );
};

export default CreateSuperAdminUserModal;
